<kkk-messenger></kkk-messenger>

<kkk-main-menu></kkk-main-menu>

<main>
  <div class="container">
    <kkk-breadcrumbs></kkk-breadcrumbs>
    <router-outlet (deactivate)="onOutletDeactivated()"></router-outlet>
  </div>
</main>

<kkk-footer></kkk-footer>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/app.component.html